// @flow
import React, { type Element } from 'react';
import DamEdit from './DamEdit';

const DamList = (): Element<*> => <DamEdit />;

export default DamList;
